import $5vbrH$macrostrathyper from "@macrostrat/hyper";
import {forwardRef as $5vbrH$forwardRef, createElement as $5vbrH$createElement} from "react";
import {expandInnerSize as $5vbrH$expandInnerSize, extractPadding as $5vbrH$extractPadding, extractMargin as $5vbrH$extractMargin, removeMargin as $5vbrH$removeMargin, removePadding as $5vbrH$removePadding} from "@macrostrat/ui-components";
import $5vbrH$classnames from "classnames";


      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;




var $aVUB5 = parcelRequire("aVUB5");

var $65790403e2a6a33e$exports = {};

$65790403e2a6a33e$exports = (parcelRequire("daZiC")).getBundleURL('5vbrH') + "storage.1d3b5786.js";


var $0db5d3ec6f72098b$exports = {};

$0db5d3ec6f72098b$exports = (parcelRequire("daZiC")).getBundleURL('5vbrH') + "column-box.5429c3c6.js";


var $2d91a1f3dec7fb54$exports = {};

$2d91a1f3dec7fb54$exports = (parcelRequire("daZiC")).getBundleURL('5vbrH') + "scroll-box.d7abcdfb.js";


const $31c5935a31dcfddd$export$59fd23dbe26daf79 = {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
};
const $31c5935a31dcfddd$export$13f4b12aafeba5d6 = (0, $5vbrH$forwardRef)((props, ref)=>{
    const { children: children, innerRef: innerRef, ...props1 } = props;
    const { style: style, ...rest } = (0, $5vbrH$expandInnerSize)(props1);
    // Sizing
    const { paddingLeft: paddingLeft, paddingTop: paddingTop } = (0, $5vbrH$extractPadding)(props);
    const margin = (0, $5vbrH$extractMargin)(props);
    const realRest = (0, $5vbrH$removeMargin)((0, $5vbrH$removePadding)(rest));
    return (0, $5vbrH$macrostrathyper)("svg", {
        ref: ref,
        style: {
            ...margin,
            ...style
        },
        ...realRest,
        ...$31c5935a31dcfddd$export$59fd23dbe26daf79
    }, (0, $5vbrH$macrostrathyper)("g", {
        transform: `translate(${paddingLeft},${paddingTop})`
    }, children));
});
const $31c5935a31dcfddd$export$86f236f5872f181 = (props)=>(0, $5vbrH$createElement)("foreignObject", props);
const $31c5935a31dcfddd$export$31992eb1fd599dfe = function(props) {
    //# Need to rework to use UI Box code
    const { children: children, className: className, innerRef: innerRef, style: style, ...rest } = props;
    const { pixelHeight: pixelHeight } = (0, $aVUB5.useColumn)();
    const nextProps = (0, $5vbrH$expandInnerSize)({
        innerHeight: pixelHeight,
        ...rest
    });
    const { paddingLeft: paddingLeft, paddingTop: paddingTop, innerHeight: innerHeight, innerWidth: innerWidth, height: height, width: width, ...remainingProps } = nextProps;
    return (0, $5vbrH$macrostrathyper)($31c5935a31dcfddd$export$13f4b12aafeba5d6, {
        className: (0, $5vbrH$classnames)(className, "section"),
        height: height,
        width: width,
        innerRef: innerRef,
        ...remainingProps,
        style: style
    }, (0, $5vbrH$macrostrathyper)("g.backdrop", {
        transform: `translate(${paddingLeft},${paddingTop})`
    }, children));
};


//# sourceMappingURL=util.c5fa2cdc.js.map
